import React from 'react'
import { useTheme } from 'styled-components'
import { Svg, SvgProps } from 'uikit'

interface MultiplierProps extends SvgProps {
  isActive: boolean
}

export const RoundMultiplierDownArrow: React.FC<MultiplierProps> = ({ isActive, ...props }) => {
  const theme = useTheme()
  const fill = isActive ? '#F9479C' : theme.colors.tertiary

  return (
    <Svg height="58px" width="140px" viewBox="0 0 140 58" {...props}>
      <g>
        <path
          d="M140 29.2078C140 32.6639 137.781 35.7292 134.497 36.8081L76.2431 55.9487C72.1877 57.2812 67.8123 57.2812 63.7569 55.9487L5.50277 36.8081C2.21938 35.7292 0 32.6639 0 29.2078V0H140V29.2078Z"
          fill={fill}
        />
      </g>
    </Svg>
  )
}

export const RoundMultiplierUpArrow: React.FC<MultiplierProps> = ({ isActive, ...props }) => {
  const theme = useTheme()
  const fill = theme.colors[isActive ? 'success' : 'tertiary']

  return (
    <Svg height="58px" width="140px" viewBox="0 0 140 58" {...props}>
      <g>
        <path
          stroke="none"
          d="M140 27.7922C140 24.3361 137.781 21.2708 134.497 20.1919L76.2431 1.05129C72.1877 -0.281194 67.8123 -0.281192 63.7569 1.05129L5.50277 20.1919C2.21938 21.2708 0 24.3361 0 27.7922V57H140V27.7922Z"
          fill={fill}
        />
      </g>
    </Svg>
  )
}
